import { z } from "zod/v4";
import { accountResponseSchema } from "../../schemas/finance";
import { fetchApi, fetchVoid } from "../client/internal";

export const accounts = {
	list: (clubId: string, params?: { sphere?: string; type?: string }) => {
		const qs = new URLSearchParams();
		if (params?.sphere) qs.set("sphere", params.sphere);
		if (params?.type) qs.set("type", params.type);
		const q = qs.toString();
		return fetchApi(`/${clubId}/accounts${q ? `?${q}` : ""}`, z.array(accountResponseSchema));
	},
	create: (clubId: string, data: unknown) =>
		fetchApi(`/${clubId}/accounts`, accountResponseSchema, {
			method: "POST",
			body: JSON.stringify(data),
		}),
	update: (clubId: string, accountId: string, data: unknown) =>
		fetchApi(`/${clubId}/accounts/${accountId}`, accountResponseSchema, {
			method: "PUT",
			body: JSON.stringify(data),
		}),
	delete: (clubId: string, accountId: string) =>
		fetchVoid(`/${clubId}/accounts/${accountId}`, { method: "DELETE" }),
	seed: (clubId: string) =>
		fetchApi(`/${clubId}/accounts/seed`, z.object({ seeded: z.number() }), {
			method: "POST",
		}),
};
